module.exports = __webpack_public_path__ + "static/img/03.e61c3ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour3/03.jpg
// module id = hwgk
// module chunks = 0